// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XYqq","left":"styles_left__17-v1","desktopActions":"styles_desktopActions__2IJs9","title":"styles_title__22N5j"};